module.exports = __webpack_public_path__ + "static/media/ticketEnviado.23eb5a8f.svg";